import {Card} from 'platform/components';
import {Show, VStack} from 'platform/foundation';

import {isNil, isNotNil} from 'ramda';

import i18n from '@dms/i18n';

import {Nullish, suffixTestId, TestIdProps} from 'shared/web';

import type {SmtpCredentialsTestRun} from '../types/SmtpCredentialsTestRun';
import {getSmtpTestChecklistRows} from '../utils/getSmtpTestChecklistRows';
import {getSmtpTestOverallPresentation} from '../utils/getSmtpTestOverallPresentation';
import {SmtpCredentialsTestChecklistItem} from './SmtpCredentialsTestChecklistItem';
import {SmtpTestStatusIconPreload} from './SmtpTestStatusIconPreload';

interface SmtpCredentialsTestResultProps extends TestIdProps {
  run: SmtpCredentialsTestRun | Nullish;
  isRunning: boolean;
}

export function SmtpCredentialsTestResult(props: SmtpCredentialsTestResultProps) {
  if (!props.isRunning && isNil(props.run)) {
    return null;
  }

  const overall = isNil(props.run) ? null : getSmtpTestOverallPresentation(props.run);

  return (
    <Card
      variant="inlineGrey"
      title={i18n.t('entity.emailService.labels.testChecklistTitle')}
      parameters={[i18n.t('entity.emailService.labels.testChecklistDescription')]}
      flags={
        !props.isRunning && isNotNil(overall)
          ? [{label: overall.label, colorScheme: overall.colorScheme, isSubtle: true}]
          : undefined
      }
      data-testid={suffixTestId('result', props)}
    >
      <Show when={props.isRunning}>
        <SmtpTestStatusIconPreload data-testid={props['data-testid']} />
      </Show>
      <VStack spacing={2}>
        {getSmtpTestChecklistRows(props.run?.tests, props.isRunning).map((row) => (
          <SmtpCredentialsTestChecklistItem
            key={row.type}
            row={row}
            data-testid={suffixTestId(`test-${row.type}`, props)}
          />
        ))}
      </VStack>
    </Card>
  );
}
